export default __webpack_public_path__ + "static/media/Desenvolvimento-de-Software-EN.87a03d40.jpg";